<div id="header">
  <div class="non-title-container">
    <button
      id="header-menu-button"
      (click)="sideNavigatorService.toggleSideNavigator()"
    >
      <img src="assets/redesign/home/menu-icon.svg" alt="Menu" />
    </button>
  </div>
  <div id="title-container" class="fake-right-padding">
    <span class="header-title">{{ title }}</span>
    <!-- <span class="header-subtitle">{{ online }}</span> -->
  </div>
</div>
